import Spline from '@splinetool/react-spline';

export default function Coin3D() {
  return (
    <Spline scene="https://prod.spline.design/LMJZhy-umNmUh5cz/scene.splinecode" />
  );
}
